import axios from 'axios'
import Moment from 'moment'
import { useEffect, useState } from 'react'
import Calendar from 'react-calendar'
import { Link, useNavigate } from 'react-router-dom'
import Indicador2 from '../../Components/Dash/indicador2'
import authService from '../../Components/Login/auth.service'
import {
  ContainerPage,
  TitleOfPage,
  TitlePage1,
  TitlePage2,
  TitlePage3
} from '../../Components/Main'
import '../../styles/components/Calendar.css'
import '../../styles/pages/relatorio.css'

import padrao from '../../Images/profile.png'
import SidebarMobile from '../../Components/SideBar-right/SidebarMobile'
import ProfileDireita from '../../Components/ProfileDireita'

function Relatorio() {
  const dateAtual = new Date()
  if (sessionStorage.DataInicio === undefined) {
    sessionStorage.DataInicio = new Date(
      dateAtual.getFullYear(),
      dateAtual.getMonth(),
      1
    )
    sessionStorage.DataFim = new Date()
  }
  const [date, setDate] = useState([
    Moment(`${sessionStorage.DataInicio} 00:00:00`).isValid()
      ? new Date(`${sessionStorage.DataInicio} 00:00:00`)
      : new Date(sessionStorage.DataInicio),
    Moment(`${sessionStorage.DataFim} 23:59:59`).isValid()
      ? new Date(`${sessionStorage.DataFim} 23:59:59`)
      : new Date(sessionStorage.DataFim)
  ])
  const setSeacrhDate = (e: any) => {
    setDate(e)
    sessionStorage.DataInicio = e[0].toISOString().slice(0, 10)
    e[1].setDate(e[1].getDate() - 1)
    sessionStorage.DataFim = e[1].toISOString().slice(0, 10)
    window.location.reload()
  }
  sessionStorage.visualizacao = 'Dashboard'
  const history = useNavigate()
  var user = authService.getCurrentUser()
  const [auditorias, setAuditorias] = useState<any[]>([])
  const [searchTerm, setSearchTerm] = useState('')
  const [notaMin, setNotaMin] = useState(0)
  const [notaMax, setNotaMax] = useState(11)

  useEffect(() => {
    axios
      .get(
        process.env.REACT_APP_API_URL +
          '/api/v1/auditoria/list/' +
          user[0].IdEmpresa +
          '/' +
          sessionStorage.IdUnidade +
          '/' +
          sessionStorage.DataInicio +
          '/' +
          sessionStorage.DataFim
      )
      .then(response => {
        setAuditorias(response.data)
      })
  }, [])
  function handleUnidadeChange(event: any) {
    sessionStorage.visualizacao = event.target.value
    //history('/ListagemRelatorio/')
    if (event.target.value === 'Dashboard') {
      history('/Relatorio/')
    }
    else if (event.target.value === 'Listagem') {
        history('/ListagemRelatorio')
    }
    else if (event.target.value === 'Checklist') {
        history('/ListagemChecklistRel')
    }
  }

  const [image, setImage] = useState(user[0].pesFoto)
  var img = new Image()
  img.src = user[0].pesFoto
  // Se foi possível carregar a imagem
  img.onload = () => {
    setImage(user[0].pesFoto)
  }
  // Caso não seja possível
  img.onerror = () => {
    setImage(padrao)
  }
  return (
    <div className="displayInteract">
      <ContainerPage>
        <div id="containerHead1">
          <div className="logo" />
        </div>

        <div id="containerHead2">
          <TitleOfPage>
            <TitlePage1>
              {sessionStorage.uniRazaoSocial} / DASHBOARD DE AUDITORIAS
            </TitlePage1>
            <Link to="/Home">{/* <TitlePage2>Auditorias</TitlePage2> */}</Link>
            <TitlePage3>DASHBOARD</TitlePage3>
          </TitleOfPage>
          <div id="containerPesquisaModal">
            <input
              className="fnamePadrao"
              placeholder="Filtrar Local"
              type="text"
              id="fname1"
              name="fname"
              onChange={event => {
                setSearchTerm(event.target.value)
              }}
            />
          </div>
        </div>
        <div className="tabelaPadraoCad1">
          {auditorias
            .filter(val => {
              if (
                searchTerm === '' &&
                parseInt(val.audNota) >= notaMin &&
                parseInt(val.audNota) < notaMax
              ) {
                return val
              } else if (searchTerm === '' && !parseInt(val.audNota)) {
                return val
              } else if (
                val.locDescricao
                  .toLowerCase()
                  .includes(searchTerm.toLowerCase()) &&
                parseInt(val.audNota) >= notaMin &&
                parseInt(val.audNota) < notaMax
              ) {
                return val
              }
            })
            .map(auditoria => (
              <div
                style={{
                  // backgroundColor: 'red',
                  cursor: 'pointer',
                  marginTop: '20px',
                  width: '180px',
                  height: '180px'
                }}
              >
                <a
                        href={`http://cozinhaesaude.hitperformance.com.br/RelatorioAuditoria/${auditoria.audCodigoGUID}`}
                        target={'_blank'}
                      >
                {/* <a
                  href={`http://ws.hitperformance.com.br/Cozinha/RelatorioAuditoria?id=${auditoria.IdRetornoAuditoria}`}
                  target={'_blank'}
                > */}
                  <Indicador2
                    p_resultado={auditoria.audNota}
                    p_restaurante={auditoria.locDescricao}
                    p_data={auditoria.audFinalizadoEm}
                    p_cor={
                      parseInt(auditoria.audNota) < 3
                        ? 'red'
                        : parseInt(auditoria.audNota) < 6 &&
                          parseInt(auditoria.audNota) >= 3
                        ? 'orange'
                        : parseInt(auditoria.audNota) < 8 &&
                          parseInt(auditoria.audNota) >= 6
                        ? 'yellow'
                        : 'green'
                    }
                  />
                </a>
              </div>
            ))}
        </div>
        <div className="cxLegendaRel">
          <label htmlFor="" className="lgHLegenda">
            Filtro:
          </label>
          <button
            className="lgHNeutro"
            onClick={event => {
              setNotaMax(11)
              setNotaMin(0)
            }}
          >
            TODAS
          </button>
          <button
            className="lgHAcima"
            onClick={event => {
              setNotaMax(11)
              setNotaMin(8)
            }}
          >
            BOM
          </button>
          <button
            className="lgHMedia"
            onClick={event => {
              setNotaMax(8)
              setNotaMin(6)
            }}
          >
            REGULAR
          </button>
          <button
            className="lgHOrange"
            onClick={event => {
              setNotaMax(6)
              setNotaMin(3)
            }}
          >
            RUIM
          </button>
          <button
            className="lgHAbaixo"
            onClick={event => {
              setNotaMax(3)
              setNotaMin(0)
            }}
          >
            INACEITÀVEL
          </button>
        </div>
      </ContainerPage>
      <nav className="esconderFiltro">
        <ProfileDireita />
        <div className="calendarRelatorio2">
          <form action="">
            <h1>Selecione:</h1>
            <label htmlFor="">Visualização:</label>
            <select
              name="IdUnidade"
              onChange={event => {
                handleUnidadeChange(event)
              }}
            >
              <option
                value={'Dashboard'}
                // selected={'Listagem' === sessionStorage.visualizacao}
              >
                Dashboard
              </option>
              <option value={'Listagem'}>Listagem</option>
              <option value={'Checklist'}>Checklist</option>
            </select>
            <label htmlFor="">Período:</label>
            <Calendar
              type="Hebrew"
              onChange={setSeacrhDate}
              defaultValue={date}
              selectRange={true}
            />
          </form>
        </div>
      </nav>

      {user[0].gruDescricao === 'Humanit' ? (
        <SidebarMobile />
      ) : user[0].gruDescricao === 'Administrativo' ? (
        <SidebarMobile />
      ) : (
        <div></div>
      )}
    </div>
  )
}

export default Relatorio
